export default __webpack_public_path__ + "static/media/linkedin.7e9194e5.svg";